import I18n from '@klook/i18n';

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function extend(Vue) {
  if (!Vue.prototype.hasOwnProperty('$i18n')) {
    Object.defineProperty(Vue.prototype, '$i18n', {
      get: function get() {
        return this._i18n;
      }
    });
  }

  Vue.prototype.$t = function (key) {
    var i18n = this.$i18n;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return i18n.t.apply(i18n, [key].concat(args));
  };

  Vue.prototype.$tc = function (key) {
    var i18n = this.$i18n;

    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return i18n.t.apply(i18n, [key].concat(args));
  };
}

// @ts-nocheck
var mixin = {
  beforeCreate: function beforeCreate() {
    var options = this.$options;

    if (options.i18n) {
      if (options.i18n instanceof VueI18n) {
        // init locale messages via custom blocks
        this._i18n = options.i18n;
      } else {
        if (process.env.NODE_ENV !== 'production') {
          console.warn('[vue-i18n] ' + "Cannot be interpreted 'i18n' option.");
        }
      }
    } else if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
      // root i18n
      this._i18n = this.$root.$i18n;
    } else if (options.parent && options.parent.$i18n && options.parent.$i18n instanceof VueI18n) {
      // parent i18n
      this._i18n = options.parent.$i18n;
    }
  }
};

var installedVue;
function install(_Vue) {
  // @ts-ignore
  install.installed = true;
  installedVue = _Vue;
  extend(installedVue);
  installedVue.mixin(mixin); // use simple mergeStrategies to prevent i18n instance lose '__proto__'

  var strats = installedVue.config.optionMergeStrategies;

  strats.i18n = function (parentVal, childVal) {
    return childVal === undefined ? parentVal : childVal;
  };
}

var VueI18n = /*#__PURE__*/function (_I18n) {
  _inheritsLoose(VueI18n, _I18n);

  function VueI18n(options) {
    var _this;

    _this = _I18n.call(this, options) || this; // @ts-ignore

    if (!installedVue && typeof window !== 'undefined' && window.Vue) {
      // @ts-ignore
      install(window.Vue);
    }

    return _this;
  }

  return VueI18n;
}(I18n);
VueI18n.install = install;

export default VueI18n;
//# sourceMappingURL=vue-i18n.esm.js.map
